import { DATA } from '../constants/titleAndMetaDescription';
const DEFAULT_ROUTE = "defaultRoute";

export default (route = DEFAULT_ROUTE) => {
    const data = DATA[route];
    return data ?? DATA[DEFAULT_ROUTE];
};